import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=0e1b9214&"
import script from "./spinner.vue?vue&type=script&lang=js&"
export * from "./spinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1b9214')) {
      api.createRecord('0e1b9214', component.options)
    } else {
      api.reload('0e1b9214', component.options)
    }
    module.hot.accept("./spinner.vue?vue&type=template&id=0e1b9214&", function () {
      api.rerender('0e1b9214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Element/spinner.vue"
export default component.exports